import { baseApi } from "./baseQuery";

// Helper function to get workspace ID from localStorage (now ObjectId)
const getWorkspaceId = (): string => localStorage.getItem("workspace_id") || "Demo";

const dashboardApi = baseApi.injectEndpoints({
  endpoints: (build) => ({

    // get bookmarks
    getBookmarks: build.query({
      query: ({ workspace_id, dashboard_name }) => {
        const workspaceId = workspace_id || getWorkspaceId();
        const activeDashboard = dashboard_name || localStorage.getItem("activeDashboard");
        return {
          url: `/api/v1/get-bookmarks?workspace_id=${workspaceId}&dashboard_name=${activeDashboard}`,
          method: "GET",
        };
      },
      providesTags: ['dashboard']
    }),

    // remove bookmark
    removeBookmark: build.mutation({
      query: (payload) => {
        return {
          url: `/api/v1/delete-bookmark?timestamp=${payload.created_at}&workspace_id=${getWorkspaceId()}&dashboard_name=${localStorage.getItem("activeDashboard")}`,
          method: "GET",
        }
      },
    }),

    // ask-google-analytics-question
    askGoogleAnalyticsQuestion: build.query({
      query: (payload) => {
        return {
          url: `/api/v1/ask-google-anaytics-question-demo?question=${payload.question}&property_id=${payload.property_id}&meta_id=${payload.meta_id}&google_ads_id=${payload.google_ads_id}&shopify_id=${payload.shopify_id}&chat_id=${payload.chat_id}&custom_bq_tool=${payload.custom_bq_tool}&workspace_id=${getWorkspaceId()}`,
          method: "GET",
        };
      },
    }),

    autoSuggestion: build.mutation({
      query: (code) => {
        return {
          url: `/api/v1/suggestions?workspace_id=${code.workspace_id}`,
          method: "POST",
          body: code
        }
      },
    }),

    sendFeedBackQuestion: build.query({
      query: (payload) => {
        return {
          url: `/api/v1/record_feedback?prompt=${payload}&workspace_id=${getWorkspaceId()}`,
          method: "GET",
        };
      },
    }),

    // Conversation page chat history api
    getChatHistory: build.query({
      query: (payload) => {
        return {
          // url: `/api/v1/get-conversation-history`,
          url: `/api/v1/get-conversation-history-demo?chat_id=${payload}&workspace_id=${getWorkspaceId()}`,

        };
      },
    }),

    // left sidebar conversation history
    getConversationHistory: build.query({
      query: () => {
        return {
          url: `/api/v1/all-conversation-history-demo?workspace_id=${getWorkspaceId()}`,
        };
      },
      providesTags: ['conversationHistory']
    }),

    // Default properties now handled via localStorage on frontend

    bookMarkConversation: build.mutation({
      query: (code) => {
        return {
          url: `/api/v1/save-bookmark?workspace_id=${getWorkspaceId()}`,
          method: "POST",
          body: code
        }
      },
    }),


    updateHistoryOrNot: build.mutation({
      query: (payload) => {
        return {
          url: `/api/v1/use-history-or-not?chat_id=${payload?.chat_id}&use_history_chat_or_not=${payload.use_history_chat_or_not}&workspace_id=${getWorkspaceId()}`,
          method: "PUT",
        }
      },
      invalidatesTags: ['useHistory']
    }),

    thumbsUpStatus: build.mutation({
      query: (payload) => {
        return {
          url: `/api/v1/update-chat-thumbs`,
          method: "POST",
          body: payload
        };
      },
    }),

    editQuestion: build.query({
      query: (payload) => {
        return {
          url: `/api/v1/edit-chat?chat_id=${payload?.chat_id}&chat_timestamp=${payload.chat_timestamp}&workspace_id=${getWorkspaceId()}`,
        };
      },
    }),

    updateChatName: build.mutation({
      query: (payload) => {
        return {
          url: `/api/v1/edit-chat-name?workspace_id=${getWorkspaceId()}`,
          method: "PUT",
          body: payload
        }
      },
      invalidatesTags: ['conversationHistory']
    }),

    deleteChatHistory: build.mutation({
      query: (payload) => {
        return {
          url: `/api/v1/delete-chat-id?workspace_id=${getWorkspaceId()}`,
          method: "DELETE",
          body: payload
        }
      },
      invalidatesTags: ['conversationHistory']
    }),

    deleteBookMarkInConversation: build.mutation({
      query: (payload) => {
        return {
          url: `/api/v1/remove-bookmark?workspace_id=${getWorkspaceId()}`,
          method: "DELETE",
          body: payload
        }
      },
    }),

    // left sidebar dashboard
    createDashboard: build.mutation({
      query: (payload) => {
        return {
          url: `/api/v1/create-dashboard?workspace_id=${getWorkspaceId()}&dashboard_name=${payload.dashboard_name}`,
          method: "POST",
        }
      },
      invalidatesTags: ['dashboard']
    }),

    getDashboardNames: build.query({
      query: () => {
        return {
          url: `/api/v1/get-dashboard-names?workspace_id=${getWorkspaceId()}`,
          method: "GET",
        };
      },
      providesTags: ['dashboard']
    }),

    editDashboard: build.query({
      query: (payload) => {
        return {
          url: `/api/v1/edit-dashboard?old_name=${payload.old_name}&new_name=${payload.new_name}&workspace_id=${getWorkspaceId()}`,
          method: "GET",
        };
      },
    }),

    deleteDashboard: build.mutation({
      query: (payload) => {
        return {
          url: `/api/v1/delete-dashboard?dashboard_name=${payload.dashboard_name}&workspace_id=${getWorkspaceId()}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ['dashboard'],
      extraOptions: {
        forceDelete: true
      }
    }),

    // CHAT DASHBOARD
    getFeedbackChat: build.query({
      query: () => {
        return {
          url: `/api/v1/get-feedback-chat?workspace_id=${getWorkspaceId()}`,
          method: "GET",
        };
      },
    }),

    updateComments: build.mutation({
      query: (payload) => {
        return {
          url: `/api/v1/update-chat-comment`,
          method: "POST",
          body: payload
        }
      },
    }),

    updateCommentType: build.mutation({
      query: (payload) => {
        return {
          url: `/api/v1/update-feedback-chat`,
          method: "POST",
          body: payload
        }
      },
    }),

    getFeedbackChatForAllUsers: build.query({
      query: () => {
        return {
          url: `/api/v1/get-chat-feedback-for-all-users?workspace_id=${getWorkspaceId()}`,
          method: "GET",
        };
      },
    }),

    deleteFeedbackChat: build.mutation({
      query: (payload) => {
        return {
          url: `/api/v1/delete-feedback-chat?workspace_id=${getWorkspaceId()}`,
          method: "POST",
          body: payload
        }
      },
    }),

    // Widget Logs API - for Oogwai testing
    getWidgetLogs: build.query({
      query: ({ workspace_id, page = 1, page_size = 50 }: { workspace_id: string; page?: number; page_size?: number }) => {
        return {
          url: `/api/v1/widget-logs?workspace_id=${workspace_id}&page=${page}&page_size=${page_size}`,
          method: "GET",
        };
      },
    }),

    // Get logs for a specific dashboard
    getWidgetLogsByDashboard: build.query({
      query: ({ dashboard_id, workspace_id, page = 1, page_size = 20 }: { dashboard_id: string; workspace_id: string; page?: number; page_size?: number }) => {
        return {
          url: `/api/v1/widget-logs/dashboard/${dashboard_id}?workspace_id=${workspace_id}&page=${page}&page_size=${page_size}`,
          method: "GET",
        };
      },
    }),

    // Get specific log detail
    getWidgetLogDetail: build.query({
      query: ({ id }: { id: string }) => {
        return {
          url: `/api/v1/widget-logs/detail?id=${id}`,
          method: "GET",
        };
      },
    }),

  }),
});

export const {
  useLazyAskGoogleAnalyticsQuestionQuery,
  useAutoSuggestionMutation,
  useLazySendFeedBackQuestionQuery,
  useLazyGetChatHistoryQuery,
  useLazyGetConversationHistoryQuery,
  // Default properties queries removed - now using localStorage
  useLazyGetBookmarksQuery,
  useRemoveBookmarkMutation,
  useBookMarkConversationMutation,
  useUpdateHistoryOrNotMutation,
  useThumbsUpStatusMutation,
  useLazyEditQuestionQuery,
  useUpdateChatNameMutation,
  useDeleteChatHistoryMutation,
  useDeleteBookMarkInConversationMutation,
  // left sidebar dashboard
  useCreateDashboardMutation,
  useLazyGetDashboardNamesQuery,
  useLazyEditDashboardQuery,
  useDeleteDashboardMutation,
  // CHAT DASHBOARD
  useGetFeedbackChatQuery,
  useUpdateCommentsMutation,
  useUpdateCommentTypeMutation,
  useGetFeedbackChatForAllUsersQuery,
  useDeleteFeedbackChatMutation,
  // Widget Logs
  useLazyGetWidgetLogsQuery,
  useLazyGetWidgetLogsByDashboardQuery,
  useLazyGetWidgetLogDetailQuery,

} = dashboardApi;